// 组件对象，大写
import showInventory from './showInventory.vue'
export default showInventory
